import React from 'react';
import RenderSvg from '../renderSvg/RenderSvg';
import "./GenericSummaryCard.css";

export interface GenericSummaryCardItemObject{
  itemLabel: string;
  itemValue1: string;
  itemValue2?: string; 
  itemStyles?: {
    container?: React.CSSProperties;
    itemValue1?: React.CSSProperties;
    itemValue2?: React.CSSProperties;
  };
  svgIcon?: string; // URL or path to the SVG icon
}

interface GenericSummaryCardProps {
  cardTitle: string;
  itemObjects?: GenericSummaryCardItemObject[];
}

const GenericSummaryCard = (
  { 
    cardTitle,
    itemObjects
  }: GenericSummaryCardProps
) => {
  return (
    <div className="GenericSummaryCard">
      <div className="GenericSummaryCardContainer">
        <div className="GenericSummaryTitle">
          <span>{cardTitle}</span>
        </div>
        <div className="GenericSummaryItemsContainer">
        {itemObjects?.map((item: GenericSummaryCardItemObject, index: any) => (
          <div key={index} className="GenericSummaryItem">
            {item.svgIcon && (
              <RenderSvg name={item.svgIcon} />
            )}
            <div className="itemDetails">
              <div className="itemLabel">{item.itemLabel}</div>
              <div className="itemValue1" style={item.itemStyles?.itemValue1}>{item.itemValue1}</div>
              {item.itemValue2 && (
                <div className="itemValue2" style={item.itemStyles?.itemValue2}>{item.itemValue2}</div>
              )}
            </div>
          </div>
        ))}
        </div>
      </div>
    </div>
  )
}

export default GenericSummaryCard;
